import { analytics, useUser } from 'libs';
import Filter from './Filter';
import Toggle from './Toggle';

const options = [{ key: 'Exclusive Rates', value: 'Exclusive Rates Only' }];

interface ExclusiveRatesFilterProps {
  filters: { programs?: string[] };
  isPro?: boolean;
  onFilter: (update: { programs: string[] }) => void;
}

const ExclusiveRatesFilter = ({ filters, isPro = false, onFilter }: ExclusiveRatesFilterProps) => {
  const { brokerage } = useUser();

  if (!brokerage) {
    return null;
  }

  const onChange = () => {
    const programs = filters.programs || [];

    const isSelected = programs.includes('Exclusive Rates');

    const newFilters = isSelected
      ? programs.filter((filter) => filter !== 'Exclusive Rates')
      : [...programs, 'Exclusive Rates'];

    analytics.productSearch.filter({
      exclusive_rates: isSelected ? 'cleared' : 'selected',
    });

    onFilter({ programs: newFilters });
  };

  return (
    <Filter
      name={`${brokerage.name}'s Exclusive Rates`}
      isPro={isPro}
      tooltip="See only the exclusive rates available to your team."
    >
      <Toggle onChange={onChange} options={options} testId="filter-exclusive-rates" value={filters.programs || []} />
    </Filter>
  );
};

export default ExclusiveRatesFilter;
